import { Box } from "@mui/material";
import { keyframes, styled } from "@mui/material/styles";

import images from "../../constants/images";

const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
`;

const pressAndMove = keyframes`
  0% { transform: translateY(0); opacity: 1; }
  30% { transform: translateY(5px); opacity: 1; }
  60% { transform: translateX(200px); opacity: 0.8; }
  100% { transform: translateX(200px); opacity: 0; }
`;

const AnimatedImg = styled("img")<{ animation?: string }>(({ animation }) => ({
  height: "full",
  width: "30px",
  animation:
    animation === "click"
      ? `${bounce} 1.5s infinite ease-in-out`
      : `${pressAndMove} 3s infinite ease-in-out`,
}));

const HandTutorial = ({
  left,
  right,
  bottom,
  animation = "click",
}: {
  left?: string;
  right?: string;
  bottom?: string;
  animation?: string;
}) => {
  return (
    <Box
      left={left}
      height={"40px"}
      width={"40px"}
      position={"absolute"}
      zIndex={50}
      right={right}
      bottom={bottom}
    >
      <AnimatedImg
        src={images.icons.HandTutorial}
        alt="HandTutorial"
        animation={animation}
      />
    </Box>
  );
};

export default HandTutorial;
